import { enableProdMode, NgZone } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { start as singleSpaStart } from 'single-spa';
import { getSingleSpaExtraProviders } from 'single-spa-angular';
import { init } from './sub-apps.loader';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { GlobalEventDistributor } from './globalEventDistributor';
import '@angular/compiler';

if (environment.production) {
  enableProdMode();
}

const appId = 'jul-web-core';

platformBrowserDynamic(getSingleSpaExtraProviders()).bootstrapModule(AppModule)
  .then(async module => {
    NgZone.isInAngularZone = () => {
      // @ts-ignore
      return window.Zone.current._properties[appId] === true;
    };

    const rootZone = module.injector.get(NgZone);
    const globalEventDistributor: GlobalEventDistributor = module.injector.get(GlobalEventDistributor);

    if (window['ngRef']) {
      window['ngRef'].destroy();
    }
    window['ngRef'] = module;
    console.log('init');

    // WAIT FOR init to finish BEFORE starting single-spa
    await init(globalEventDistributor);

    singleSpaStart(); // ✅ Moved here, AFTER apps are registered

    rootZone['_inner']._properties[appId] = true;
  })
  .catch(err => console.error(err));